import React from 'react';

export const PlayIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			width='64.037'
			height='64.037'
			viewBox='0 0 64.037 64.037'
		>
			<defs>
				<filter
					id='Exclusion_1'
					x='0'
					y='0'
					width='64.037'
					height='64.037'
					filterUnits='userSpaceOnUse'
				>
					<feOffset dy='3' />
					<feGaussianBlur stdDeviation='3' result='blur' />
					<feFlood floodOpacity='0.161' />
					<feComposite operator='in' in2='blur' />
					<feComposite in='SourceGraphic' />
				</filter>
			</defs>
			<g id='play' transform='translate(9 6)'>
				<g transform='matrix(1, 0, 0, 1, -9, -6)' filter='url(#Exclusion_1)'>
					<path
						id='Exclusion_1-2'
						data-name='Exclusion 1'
						d='M23.018,46.037A23.008,23.008,0,0,1,0,23.02a23.024,23.024,0,0,1,44.229-8.961,23.015,23.015,0,0,1-21.21,31.978Zm-2.985-30.58V30.569l10.359-7.556L20.033,15.456Z'
						transform='translate(9 6)'
						fill='#fff'
					/>
				</g>
			</g>
		</svg>
	);
};

export const PodCast = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='46.001'
			height='52.573'
			viewBox='0 0 46.001 52.573'
		>
			<g id='podcast' transform='translate(-482 -16)'>
				<path
					id='Icon_awesome-podcast'
					data-name='Icon awesome-podcast'
					d='M27.46,50.166c-.528,1.952-2.523,2.407-4.459,2.407s-3.931-.455-4.459-2.407a74.821,74.821,0,0,1-2.112-13.637c0-3.61,3.2-4.492,6.572-4.492s6.572.882,6.572,4.492A74.9,74.9,0,0,1,27.46,50.166ZM16.107,29.629a9.857,9.857,0,1,1,13.787,0,.618.618,0,0,0,.064.943,6.831,6.831,0,0,1,2.18,2.6.612.612,0,0,0,.97.194,14.786,14.786,0,1,0-20.217,0,.612.612,0,0,0,.971-.194,6.831,6.831,0,0,1,2.18-2.6.617.617,0,0,0,.065-.943ZM23,0a23.007,23.007,0,0,0-10.09,43.681.616.616,0,0,0,.876-.648c-.245-1.593-.446-3.178-.555-4.553a.619.619,0,0,0-.275-.463,18.071,18.071,0,1,1,19.834.166c-.1,1.441-.315,3.141-.577,4.85a.616.616,0,0,0,.876.648A23.007,23.007,0,0,0,23,0Zm0,16.429A6.572,6.572,0,1,0,29.572,23,6.572,6.572,0,0,0,23,16.429Z'
					transform='translate(482 16)'
					fill='#fff'
				/>
			</g>
		</svg>
	);
};

export const GenericVideo = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			width='38.953'
			height='22.324'
			viewBox='0 0 38.953 22.324'
		>
			<defs>
				<clipPath id='clip-path'>
					<rect
						id='Rectangle_17646'
						data-name='Rectangle 17646'
						width='38.953'
						height='22.324'
						fill='#c7c7c7'
					/>
				</clipPath>
			</defs>
			<g
				id='generic_video_ico'
				data-name='generic video ico'
				transform='translate(0 0)'
			>
				<g
					id='Group_34470'
					data-name='Group 34470'
					transform='translate(0 0)'
					clip-path='url(#clip-path)'
				>
					<path
						id='Path_20008'
						data-name='Path 20008'
						d='M117.252,11.671,113.6,14.653h-4.3V25.4h4.3l3.654,2.982a1,1,0,0,0,1.639-.779V12.45a1,1,0,0,0-1.639-.779'
						transform='translate(-79.937 -8.366)'
						fill='#c7c7c7'
					/>
					<path
						id='Path_20009'
						data-name='Path 20009'
						d='M24.93,2H2.686A2.694,2.694,0,0,0,0,4.686V17.638a2.694,2.694,0,0,0,2.686,2.686H24.9a2.694,2.694,0,0,0,2.686-2.686V4.713A2.661,2.661,0,0,0,24.93,2m-7.6,10.143-6.071,3.036A1.078,1.078,0,0,1,9.7,14.211V8.14a1.078,1.078,0,0,1,1.558-.967l6.071,3.036a1.076,1.076,0,0,1,0,1.934'
						transform='translate(0 0)'
						fill='#c7c7c7'
					/>
				</g>
			</g>
		</svg>
	);
};

export const Link = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='20.182'
			height='20.182'
			viewBox='0 0 20.182 20.182'
		>
			<g id='link' transform='translate(-557 -32)'>
				<path
					id='link-2'
					data-name='link'
					d='M10.653.563A10.091,10.091,0,1,1,.563,10.653,10.089,10.089,0,0,1,10.653.563ZM9.477,6.405l3.072,2.946H5.12a.974.974,0,0,0-.977.977v.651a.974.974,0,0,0,.977.977h7.43L9.477,14.9a.978.978,0,0,0-.016,1.4l.448.444a.973.973,0,0,0,1.379,0l5.4-5.4a.972.972,0,0,0,0-1.379l-5.4-5.4a.973.973,0,0,0-1.379,0l-.448.444a.982.982,0,0,0,.016,1.4Z'
					transform='translate(556.438 31.438)'
				/>
			</g>
		</svg>
	);
};
